import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import React from "react";
import styles from "./range_slider.module.sass";

export type RangeSliderProps = {
  min: number;
  max: number;
  value?: [number, number];
  defaultValue?: [number, number];
  onChange?: (newValue: [number, number]) => void;
  onAfterChange?: (newValue: [number, number]) => void;
};

export const RangeSlider = ({
  min,
  max,
  defaultValue,
  value,
  onAfterChange,
  onChange,
}: RangeSliderProps): JSX.Element => (
  <Slider.Range
    min={min}
    max={max}
    defaultValue={defaultValue}
    value={value}
    onChange={onChange as (values: number[]) => void}
    onAfterChange={onAfterChange as (values: number[]) => void}
    className={styles.rangeSlider}
  />
);
